
import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from '@/core/di/Inject';
import { TYPES } from '@/core/config/Types';
import OperationRegisterForm from './OperationRegisterForm.vue';
import { WmsQuotationOrder } from '@/courier/domain/wmsQuotationOrder/WmsQuotationOrder';
import { CreateQuotation } from '@/courier/application/uses_cases/order/create/CreateQuotation';
import { WmsOrderLine } from '@/courier/domain/orderline/WmsOrderLine';
@Component({
  name: 'OperationRegisterCenter',
  components: { OperationRegisterForm }
})
export default class OperationRegisterCenter extends Vue {
  @Inject(TYPES.QUOTATIONS_SAVE)
  readonly saveQuotation!: CreateQuotation;
  //DATOS
  isLoading = false;
  //FORMULARIO
  form: WmsQuotationOrder = new WmsQuotationOrder();
  containers: WmsOrderLine[] = [];
  boxes: WmsOrderLine[] = [];
  bulks: WmsOrderLine[] = [];

  //OBJETO DE ACCIONES
  actions = {
    save: this.save,
    clear: this.clearForm
  };

  //Funcion invocada para guardar la cotización
  async save() {
    try {
      this.isLoading = true;
      await this.saveQuotation.execute(this.form);
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }

  //Funcion para limpiar el formulario
  clearForm() {
    this.form = new WmsQuotationOrder();
    this.containers = [];
    this.boxes = [];
    this.bulks = [];
  }
}
